// @flow

import { css } from 'styled-components';
import getPadding from './getPadding';
import type { StyledButtonProps } from '../types';
import type { ButtonSchemeName } from '../../../types/theme';
import getGradient from './getGradient';

export default (colorScheme: ButtonSchemeName, props: StyledButtonProps) => {
  const gradient = getGradient(props.theme.buttons.gradient, colorScheme);

  return css`
    background-color: ${props.theme.buttons.scheme[colorScheme].main};
    color: ${props.theme.buttons.scheme[colorScheme].contrast};
    border-color: transparent;
    padding: ${getPadding(Boolean(props.withIcon), props)};

    ${gradient && css`
      background-color: transparent;
      background-image: ${gradient.main};
      color: ${gradient.contrast};
      /* next three lines it to prevent the background from showing underneath gradient */
      background-repeat: no-repeat;
      background-size: calc(100% + 2px) calc(100% + 2px);
      background-position: -1px -1px;
    `}

    ${props.caret && css`
      &:after {
        border-color: ${props.theme.buttons.scheme[colorScheme].contrast};
      }
    `}
    
    && {
      &:hover,
      &:focus,
      &:active,
      &:visited {
        color: ${props.theme.buttons.scheme[colorScheme].contrast};
        text-decoration: none;

        ${gradient && css`
          background-image: ${gradient.hover};
          color: ${gradient.contrast};
        `}

        ${props.caret && css`
          &:after {
            border-color: ${props.theme.buttons.scheme[colorScheme].contrast};
          }
        `}
      }
    }

    &:hover {
      background-color: ${props.theme.buttons.scheme[colorScheme].hover};
      ${props.caret && css`
        &:after {
          border-color: ${props.theme.buttons.scheme[colorScheme].contrast};
        }
      `}
    }

    &:focus,
    &:active {
      background-color: ${props.theme.buttons.scheme[colorScheme].active};
      ${props.caret && css`
        &:after {
          border-color: ${props.theme.buttons.scheme[colorScheme].active};
        }
      `}
    }
  `;
};
